var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDepth = function SvgDepth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "depth_svg__Layer_1",
    viewBox: "0 0 30 35"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "depth_svg__clippath"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.8-.2h33.7v35.3H-3.8z",
    className: "depth_svg__st0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "depth_svg__clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.8-.2h33.7v35.3H-3.8z",
    className: "depth_svg__st0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "depth_svg__clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.8-.2h33.7v35.3H-3.8z",
    className: "depth_svg__st0"
  })), /*#__PURE__*/React.createElement("style", null, ".depth_svg__st0,.depth_svg__st1{fill:none}.depth_svg__st1{stroke-width:.5px;stroke:#000;stroke-linejoin:bevel}.depth_svg__st7{fill:#fff}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4 9.5v21.7L9.9 34.7V13l10.3-1.8z",
    className: "depth_svg__st7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.4 9.5v21.7L9.9 34.7V13l10.3-1.8z",
    className: "depth_svg__st1",
    style: {
      clipPath: "url(#depth_svg__clippath)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.4 9.5-9.2 1.7L9.9 13 .7 3.9 20.2.4z",
    style: {
      fill: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.4 9.5-9.2 1.7L9.9 13 .7 3.9 20.2.4z",
    className: "depth_svg__st1",
    style: {
      clipPath: "url(#depth_svg__clippath-1)"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9 13v21.7L.7 25.5V3.9z",
    className: "depth_svg__st7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.9 13v21.7L.7 25.5V3.9z",
    className: "depth_svg__st1",
    style: {
      clipPath: "url(#depth_svg__clippath-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.5 3.4 7.1 6.6",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.9 3.4 5.5 6.4",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "bevel"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12.2 7.3.7.1.2-3.7 3.6.3.1-.7-4.5-.5zM14.5 9.9v-.7l3.7.4.1-3.7h.8l-.2 4.5z"
  })));
};
export { SvgDepth as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiB2aWV3Qm94PSIwIDAgMzAgMzUiPgogIDwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyOS44LjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiAyLjEuMSBCdWlsZCAyKSAgLS0+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5zdDAsIC5zdDEsIC5zdDIgewogICAgICAgIGZpbGw6IG5vbmU7CiAgICAgIH0KCiAgICAgIC5zdDMgewogICAgICAgIGZpbGw6ICNlNmU2ZTY7CiAgICAgIH0KCiAgICAgIC5zdDQgewogICAgICAgIGZpbGw6ICNjNmM2YzY7CiAgICAgIH0KCiAgICAgIC5zdDEgewogICAgICAgIHN0cm9rZS13aWR0aDogLjVweDsKICAgICAgfQoKICAgICAgLnN0MSwgLnN0MiB7CiAgICAgICAgc3Ryb2tlOiAjMDAwOwogICAgICAgIHN0cm9rZS1saW5lam9pbjogYmV2ZWw7CiAgICAgIH0KCiAgICAgIC5zdDUgewogICAgICAgIGNsaXAtcGF0aDogdXJsKCNjbGlwcGF0aC0xKTsKICAgICAgfQoKICAgICAgLnN0NiB7CiAgICAgICAgY2xpcC1wYXRoOiB1cmwoI2NsaXBwYXRoLTIpOwogICAgICB9CgogICAgICAuc3Q3IHsKICAgICAgICBmaWxsOiAjZmZmOwogICAgICB9CgogICAgICAuc3Q4IHsKICAgICAgICBjbGlwLXBhdGg6IHVybCgjY2xpcHBhdGgpOwogICAgICB9CiAgICA8L3N0eWxlPgogICAgPGNsaXBQYXRoIGlkPSJjbGlwcGF0aCI+CiAgICAgIDxyZWN0IGNsYXNzPSJzdDAiIHg9Ii0zLjgiIHk9Ii0uMiIgd2lkdGg9IjMzLjciIGhlaWdodD0iMzUuMyIvPgogICAgPC9jbGlwUGF0aD4KICAgIDxjbGlwUGF0aCBpZD0iY2xpcHBhdGgtMSI+CiAgICAgIDxyZWN0IGNsYXNzPSJzdDAiIHg9Ii0zLjgiIHk9Ii0uMiIgd2lkdGg9IjMzLjciIGhlaWdodD0iMzUuMyIvPgogICAgPC9jbGlwUGF0aD4KICAgIDxjbGlwUGF0aCBpZD0iY2xpcHBhdGgtMiI+CiAgICAgIDxyZWN0IGNsYXNzPSJzdDAiIHg9Ii0zLjgiIHk9Ii0uMiIgd2lkdGg9IjMzLjciIGhlaWdodD0iMzUuMyIvPgogICAgPC9jbGlwUGF0aD4KICA8L2RlZnM+CiAgPHBvbHlnb24gY2xhc3M9InN0NyIgcG9pbnRzPSIyOS40IDkuNSAyOS40IDMxLjIgOS45IDM0LjcgOS45IDEzIDIwLjIgMTEuMiAyOS40IDkuNSIvPgogIDxnIGNsYXNzPSJzdDgiPgogICAgPHBvbHlnb24gY2xhc3M9InN0MSIgcG9pbnRzPSIyOS40IDkuNSAyOS40IDMxLjIgOS45IDM0LjcgOS45IDEzIDIwLjIgMTEuMiAyOS40IDkuNSIvPgogIDwvZz4KICA8cG9seWdvbiBjbGFzcz0ic3Q0IiBwb2ludHM9IjI5LjQgOS41IDIwLjIgMTEuMiA5LjkgMTMgLjcgMy45IDIwLjIgLjQgMjkuNCA5LjUiLz4KICA8ZyBjbGFzcz0ic3Q1Ij4KICAgIDxwb2x5Z29uIGNsYXNzPSJzdDEiIHBvaW50cz0iMjkuNCA5LjUgMjAuMiAxMS4yIDkuOSAxMyAuNyAzLjkgMjAuMiAuNCAyOS40IDkuNSIvPgogIDwvZz4KICA8cG9seWdvbiBjbGFzcz0ic3Q3IiBwb2ludHM9IjkuOSAxMyA5LjkgMzQuNyAuNyAyNS41IC43IDMuOSA5LjkgMTMiLz4KICA8ZyBjbGFzcz0ic3Q2Ij4KICAgIDxwb2x5Z29uIGNsYXNzPSJzdDEiIHBvaW50cz0iOS45IDEzIDkuOSAzNC43IC43IDI1LjUgLjcgMy45IDkuOSAxMyIvPgogIDwvZz4KICA8bGluZSBjbGFzcz0ic3QzIiB4MT0iMTEuNSIgeTE9IjMuNCIgeDI9IjE4LjYiIHkyPSIxMCIvPgogIDxnPgogICAgPGxpbmUgY2xhc3M9InN0MiIgeDE9IjEyLjkiIHkxPSIzLjQiIHgyPSIxOC40IiB5Mj0iOS44Ii8+CiAgICA8cG9seWdvbiBwb2ludHM9IjEyLjIgNy4zIDEyLjkgNy40IDEzLjEgMy43IDE2LjcgNCAxNi44IDMuMyAxMi4zIDIuOCAxMi4yIDcuMyIvPgogICAgPHBvbHlnb24gcG9pbnRzPSIxNC41IDkuOSAxNC41IDkuMiAxOC4yIDkuNiAxOC4zIDUuOSAxOS4xIDUuOSAxOC45IDEwLjQgMTQuNSA5LjkiLz4KICA8L2c+Cjwvc3ZnPg==";